import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useAuth } from '@/hooks'
import { isAdvancedPlan } from '../constants/userSubscriptionPlans'

const isAbleToSetSpyModeUsers = [
  'ca6e2eb2-23e3-5861-8c02-de46a19458da', // prod-k
  'bcda11c8-a0fd-5b47-be78-0fb45aafe9cf', // prod-o
  '5fac2282-00e6-52d4-a97a-e1654c275e03', // prod-a
  'f72c055f-8219-417a-b08c-b1aba5f8d3c2', // dev-oknemi
  '538f0376-fa80-40c1-9468-1891f423b115', // dev-karl
  '0556838d-fff3-4d42-97f0-966c8acaf575', // dev-edgars

  'a3088c05-e076-4ea1-9232-352029a284a7', // dev-denis
  '37fc0000-8e5f-478f-914e-0251ddd35b48',
  '927820e0-bc02-4c7a-8750-79e938ab4fc7',
  'bdc5e256-aaa6-4c6f-ad73-efce844bfc16',
  '8e268305-8ed5-4e38-9790-00d094bf9489',

  '83dfa01f-9ba9-4b7e-b38b-e949ead2fdc6', // prod-denis
  '8165650c-d038-5f66-92be-5feaebaef788', // prod-maksim
  '29ce3ac1-c017-5053-824c-6a593eeba1a6', // prod-edgars
  '0da0fd53-a162-4cde-9b1d-0a0cfc9cb3e5', // prod-dmitriiL
]

const useFeatureFlags = () => {
  const { authenticated, id: userId, planId } = useAuth()
  // todo: убрать обращение к поисковой строке
  const { workspaceId, uuid = null } = useParams<{
    workspaceId: string
    uuid: string
  }>()
  // The editor route carries no workspace segment, so the URL cannot say whether the
  // crawl belongs to a paid space. The open project's owner plan can, and it is the
  // honest signal anyway: a crawl into a project follows that project's plan.
  //
  // Read only while the URL is still that project's. Leaving a project does not clear
  // `manager` — RESET_PROJECT fires on the way in, not on the way out — so a plain read
  // of the slice would carry the last project's owner plan to the dashboard, and a free
  // user who had opened a PRO owner's project would crawl on PRO limits there.
  const openProjectId = useSelector(
    (state: AppState) => state.manager?.meta?.id ?? null
  )
  const ownerPlan = useSelector(
    (state: AppState) => state.manager?.meta?.ownerPlan ?? null
  )
  const projectOwnerPlan =
    uuid !== null && uuid === openProjectId ? ownerPlan : null

  return {
    viewers: {
      isAbleToSetSpyMode:
        authenticated && isAbleToSetSpyModeUsers.includes(userId),
    },
    crawler: {
      // личное пространство теперь тоже имеет сегмент в урле (/dashboard/my),
      // поэтому оно не признак командного воркспейса
      userHasMaximumLimit:
        (authenticated && isAdvancedPlan(planId)) ||
        (Boolean(workspaceId) && workspaceId !== PERSONAL_WORKSPACE_ID) ||
        (projectOwnerPlan !== null && isAdvancedPlan(projectOwnerPlan)),
    },
  }
}

export default useFeatureFlags
